import { routerMiddleware, routerReducer } from 'react-router-redux';
// import { createEpicMiddleware } from 'redux-observable';
import { createBrowserHistory } from 'history';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { reducer as rformReducer } from 'redux-form';
import { reducers as toastReducers } from 'src/toast';
import { categoriesReducer, categoryDetailReducer } from 'src/categories';
import { statesReducer, stateDetailReducer } from 'src/states';
import { townshipsReducer, townshipDetailReducer } from 'src/townships';
import { merchantsReducer, merchantDetailReducer } from 'src/merchants';
import { membersReducer, memberDetailReducer } from 'src/members';
import { featuredAdsReducer, featuredAdsDetailReducer } from 'src/featuredAds';
import { featuredCategoriesReducer, featuredCategoryDetailReducer } from 'src/featuredCategories';
import { trendingCategoriesReducer, trendingCategoryDetailReducer } from 'src/trendingCategories';
import epic from 'src/epic';

// redux
const reduxCombineReducers: any = combineReducers; //tslint:disable-line
import { reducers as authReducers } from 'src/auth';
import { createEpicMiddleware } from 'redux-observable';
const reducer = reduxCombineReducers({
  authState: authReducers.authReducer,
  form: rformReducer,
  router: routerReducer,
  messagesState: toastReducers.reducer,
  statesState: statesReducer,
  stateDetailState: stateDetailReducer,
  categoriesState: categoriesReducer,
  categoryDetailState: categoryDetailReducer,
  townshipsState: townshipsReducer,
  townshipDetailState: townshipDetailReducer,
  featuredAdsState: featuredAdsReducer,
  featuredAdsDetailState: featuredAdsDetailReducer,
  featuredCategoriesState: featuredCategoriesReducer,
  featuredCategoryDetailState: featuredCategoryDetailReducer,
  trendingCategoriesState: trendingCategoriesReducer,
  trendingCategoryDetailState: trendingCategoryDetailReducer,
  merchantsState: merchantsReducer,
  merchantDetailState: merchantDetailReducer,
  membersState: membersReducer,
  memberDetailState: memberDetailReducer,
});

class RWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: typeof compose;
}

const rwindow = window as RWindow;
const composeEnhancers = rwindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const epicMiddleware = createEpicMiddleware(epic);
const history = createBrowserHistory();

const store = createStore(
  reducer,
  composeEnhancers(
    applyMiddleware(epicMiddleware, routerMiddleware(history)),
  )
);

export * from './state';
export {
  store,
  history
};



// WEBPACK FOOTER //
// ./src/store/index.ts